import { useEffect } from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box,
  Center,
  Image,
  Spinner,
  Stack
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import {
  connectionRequestSeenAll,
  getProfileItem,
  setConnReqData,
  setGetProfileItemStatus,
  setNotificationSectionPage,
  setOpenFriendRequest,
  setProfileItemId,
  markersSelectors,
  usersSelectors
} from 'store'
import {
  NotificationSections,
  PENDING,
  SUCCEEDED
} from 'utils/constants'

export const RequestItems = ({
  notificationItems,
  type
}) => {
  const dispatch = useDispatch()

  const {
    adminNotifRequest,
    connReqData,
    getAdminNotificationsStatus,
    getBlogPreferenceStatus,
    getEngagementItemsStatus,
    getPostsStatus,
    getProfileItemStatus,
    getSavedEventsStatus,
    openFriendRequest,
    profileItemId,
    postMakeNotificationSeenAllStatus
  } = useSelector(usersSelectors)

  const {
    getEventDataStatus,
    singleMarkerUpdateStatus
  } = useSelector(markersSelectors)

  const isAvailable = (item) => item?.sender_id === profileItemId > 0
    || (
      getProfileItemStatus === PENDING
      && profileItemId
    )
    || getPostsStatus === PENDING
    || postMakeNotificationSeenAllStatus === PENDING
    || getProfileItemStatus === PENDING
    || getEventDataStatus === PENDING
    || getEngagementItemsStatus === PENDING
    || getBlogPreferenceStatus === PENDING
    || singleMarkerUpdateStatus === PENDING
    || getSavedEventsStatus === PENDING
    || sessionStorage.getItem('openProfileAfterAnimation')

  const handleClick = (item) => {
    if (localStorage.getItem('is-notif-modal-open') === 'false') {
      let waitTime = 0
      if (
        document.querySelector('#chakra-modal-blog-drawer')
        || document.querySelector('#chakra-modal-event-drawer')
      ) {
        document.querySelector('#force-close-blog-drawer')?.click()
        document.querySelector('#force-close-event-drawer')?.click()
        waitTime = 900
        dispatch(getProfileItem.pending())
      }

      setTimeout(() => {
        if (notificationItems.find((fn) => !fn.is_viewed)) {
          dispatch(connectionRequestSeenAll())
        }

        if (item?.sender_id === profileItemId) {
          dispatch(getProfileItem(item?.sender_id))
        } else {
          dispatch(getProfileItem.pending())
          dispatch(setProfileItemId(item?.sender_id))
        }
        dispatch(setConnReqData(item))

        localStorage.setItem('friendReqID', item?.friend_request_id)
        sessionStorage.setItem('id', item?.sender_id)
      }, waitTime)
    }
  }

  useEffect(() => {
    if (
      getProfileItemStatus === SUCCEEDED
      && Object.keys(connReqData).length
    ) {
      dispatch(setNotificationSectionPage({
        key: NotificationSections.CONNECTION_REQUEST,
        title: 'Connection Request'
      }))

      dispatch(setGetProfileItemStatus(0))
    }
  }, [getProfileItemStatus])

  useEffect(() => {
    if (
      openFriendRequest
      && adminNotifRequest !== null
      && getAdminNotificationsStatus !== PENDING
    ) {
      let reqData = notificationItems.find((item) => item?.sender_id === openFriendRequest)
      dispatch(setOpenFriendRequest(null))

      if (reqData) {
        setTimeout(() => handleClick(reqData), 1000)
      }
    }
  }, [openFriendRequest])

  return (
    <Stack
      spacing="55px"
      id={`${type}-connection-request-list`}
      paddingBottom={notificationItems.length > 3 ? '5px' : null}
      marginLeft="5px"
      marginRight="5px"
      overflowX="auto"
      display="flex"
      flexDirection="row"
      gap="0px"
      css={{
        '&::-webkit-scrollbar': {
          width: '4px',
          height: '10px',
          display: 'block'
        },
        '&::-webkit-scrollbar-track': {
          width: '6px'
        },
        '&::-webkit-scrollbar-thumb': {
          borderRadius: '24px',
          background: 'rgba(255, 215, 0, 1)'
        }
      }}
    >
      {
        notificationItems.map((item) => (
          <Stack id={item?.sender_id}>
            <Box
              cursor="pointer"
              onClick={() => handleClick(item)}
              sx={{
                minWidth: '118px',
                marginTop: '5px'
              }}
              data-name="notificationItem"
              position="relative"
              pointerEvents={isAvailable(item) || item?.disabled ? 'none' : 'auto'}
              opacity={isAvailable(item) || item?.disabled ? 0.7 : 1}
            >
              {
                getProfileItemStatus === PENDING
                && (
                  item?.sender_id === profileItemId
                  || item?.sender_id === connReqData?.sender_id
                )
                  ? (
                    <Center position="absolute">
                      <Spinner
                        width="60px"
                        height="60px"
                        position="sticky"
                        marginLeft="25px"
                        marginTop="25px"
                        zIndex={5}
                      />
                    </Center>
                  ) : null
              }
              <Image
                width="108px"
                height="108px"
                opacity={
                  getProfileItemStatus === PENDING
                  && item?.sender_id === profileItemId ? 0.7 : 1
                }
                objectFit="cover"
                src={item.profile_picture ?? ImagesPng.DefaultImage}
                alt={item?.title}
                borderRadius="5px"
              />
            </Box>
          </Stack>
        ))
      }
    </Stack>
  )
}
